import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const Authenticate = ({ children }) => {
  const token = localStorage.getItem("accessToken");
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default Authenticate;
